// Object type mappings extracted from Solidity ObjectTypes library
// Based on the actual ObjectType.wrap() values from the contract
export const OBJECT_TYPES: Record<number, string> = {
  0: "Null",
  1: "Air",
  2: "Water",
  3: "Bedrock",
  4: "Stone",
  5: "Deepslate",
  6: "Granite",
  7: "Tuff",
  8: "Calcite",
  9: "Basalt",
  10: "SmoothBasalt",
  11: "Andesite",
  12: "Diorite",
  13: "Cobblestone",
  14: "MossyCobblestone",
  15: "Obsidian",
  16: "Dripstone",
  17: "Blackstone",
  18: "CobbledDeepslate",
  19: "Amethyst",
  20: "Glowstone",
  21: "Grass",
  22: "Dirt",
  23: "Moss",
  24: "Podzol",
  25: "DirtPath",
  26: "Mud",
  27: "PackedMud",
  28: "Farmland",
  29: "WetFarmland",
  30: "UnrevealedOre",
  31: "Gravel",
  32: "Sand",
  33: "RedSand",
  34: "Sandstone",
  35: "RedSandstone",
  36: "Clay",
  37: "Terracotta",
  38: "BrownTerracotta",
  39: "OrangeTerracotta",
  40: "WhiteTerracotta",
  41: "LightGrayTerracotta",
  42: "YellowTerracotta",
  43: "RedTerracotta",
  44: "LightBlueTerracotta",
  45: "CyanTerracotta",
  46: "BlackTerracotta",
  47: "PurpleTerracotta",
  48: "BlueTerracotta",
  49: "MagentaTerracotta",
  50: "OakLog",
  51: "BirchLog",
  52: "JungleLog",
  53: "SakuraLog",
  54: "AcaciaLog",
  55: "SpruceLog",
  56: "DarkOakLog",
  57: "MangroveLog",
  58: "OakLeaf",
  59: "BirchLeaf",
  60: "JungleLeaf",
  61: "SakuraLeaf",
  62: "SpruceLeaf",
  63: "AcaciaLeaf",
  64: "DarkOakLeaf",
  65: "AzaleaLeaf",
  66: "FloweringAzaleaLeaf",
  67: "MangroveLeaf",
  68: "MangroveRoots",
  69: "MuddyMangroveRoots",
  70: "AzaleaFlower",
  71: "BellFlower",
  72: "DandelionFlower",
  73: "DaylilyFlower",
  74: "LilacFlower",
  75: "RoseFlower",
  76: "FireFlower",
  77: "MorninggloryFlower",
  78: "PeonyFlower",
  79: "Ultraviolet",
  80: "SunFlower",
  81: "FlyTrap",
  82: "FescueGrass",
  83: "SwitchGrass",
  84: "VinesBush",
  85: "IvyVine",
  86: "HempBush",
  87: "GoldenMushroom",
  88: "RedMushroom",
  89: "CoffeeBush",
  90: "StrawberryBush",
  91: "RaspberryBush",
  92: "Wheat",
  93: "CottonBush",
  94: "Pumpkin",
  95: "Melon",
  96: "RedMushroomBlock",
  97: "BrownMushroomBlock",
  98: "MushroomStem",
  99: "BambooBush",
  100: "Cactus",
  101: "Coral",
  102: "SeaAnemone",
  103: "Algae",
  104: "HornCoralBlock",
  105: "FireCoralBlock",
  106: "TubeCoralBlock",
  107: "BubbleCoralBlock",
  108: "BrainCoralBlock",
  109: "Snow",
  110: "Ice",
  111: "Lava",
  112: "SpiderWeb",
  113: "Bone",
  114: "CoalOre",
  115: "CopperOre",
  116: "IronOre",
  117: "GoldOre",
  118: "DiamondOre",
  119: "NeptuniumOre",
  120: "TextSign",
  121: "OakPlanks",
  122: "BirchPlanks",
  123: "JunglePlanks",
  124: "SakuraPlanks",
  125: "SprucePlanks",
  126: "AcaciaPlanks",
  127: "DarkOakPlanks",
  128: "MangrovePlanks",
  129: "CopperBlock",
  130: "IronBlock",
  131: "GoldBlock",
  132: "DiamondBlock",
  133: "NeptuniumBlock",
  134: "WheatSeed",
  135: "PumpkinSeed",
  136: "MelonSeed",
  137: "OakSapling",
  138: "BirchSapling",
  139: "JungleSapling",
  140: "SakuraSapling",
  141: "AcaciaSapling",
  142: "SpruceSapling",
  143: "DarkOakSapling",
  144: "MangroveSapling",
  145: "ForceField",
  146: "Chest",
  147: "SpawnTile",
  148: "Bed",
  149: "Workbench",
  150: "Powerstone",
  151: "Furnace",
  152: "Torch",
  153: "GreenTerracotta",
  154: "PinkTerracotta",
  155: "LimeTerracotta",
  156: "GrayTerracotta",
  256: "Stonecutter",
  257: "StoneBricks",
  258: "TuffBricks",
  259: "DeepslateBricks",
  260: "PolishedAndesite",
  261: "PolishedGranite",
  262: "PolishedDiorite",
  263: "PolishedTuff",
  264: "PolishedBasalt",
  265: "PolishedBlackstone",
  266: "ChiseledStoneBricks",
  267: "ChiseledTuffBricks",
  268: "ChiseledDeepslate",
  269: "ChiseledPolishedBlackstone",
  270: "ChiseledSandstone",
  271: "ChiseledRedSandstone",
  272: "CrackedStoneBricks",
  274: "CrackedDeepslateBricks",
  275: "SmoothSandstone",
  276: "SmoothRedSandstone",
  277: "SmoothStone",
  278: "PolishedDeepslate",
  279: "PolishedBlackstoneBricks",
  280: "CrackedPolishedBlackstoneBricks",
  281: "MossyStoneBricks",
  282: "CutSandstone",
  283: "CutRedSandstone",
  284: "RedDye",
  285: "YellowDye",
  286: "BlueDye",
  287: "GreenDye",
  288: "WhiteDye",
  289: "BlackDye",
  290: "BrownDye",
  291: "OrangeDye",
  292: "PinkDye",
  293: "LimeDye",
  294: "CyanDye",
  295: "GrayDye",
  296: "PurpleDye",
  297: "MagentaDye",
  298: "LightBlueDye",
  299: "LightGrayDye",
  318: "Glass",
  319: "WhiteGlass",
  320: "OrangeGlass",
  323: "YellowGlass",
  325: "PinkGlass",
  329: "PurpleGlass",
  330: "BlueGlass",
  332: "GreenGlass",
  333: "RedGlass",
  334: "BlackGlass",
  352: "WhiteConcretePowder",
  353: "OrangeConcretePowder",
  354: "MagentaConcretePowder",
  355: "LightBlueConcretePowder",
  356: "YellowConcretePowder",
  357: "LimeConcretePowder",
  358: "PinkConcretePowder",
  359: "GrayConcretePowder",
  360: "LightGrayConcretePowder",
  361: "CyanConcretePowder",
  362: "PurpleConcretePowder",
  363: "BlueConcretePowder",
  364: "BrownConcretePowder",
  365: "GreenConcretePowder",
  366: "RedConcretePowder",
  367: "BlackConcretePowder",
  368: "WhiteConcrete",
  369: "OrangeConcrete",
  370: "MagentaConcrete",
  371: "LightBlueConcrete",
  372: "YellowConcrete",
  373: "LimeConcrete",
  374: "PinkConcrete",
  375: "GrayConcrete",
  376: "LightGrayConcrete",
  377: "CyanConcrete",
  378: "PurpleConcrete",
  379: "BlueConcrete",
  380: "BrownConcrete",
  381: "GreenConcrete",
  382: "RedConcrete",
  383: "BlackConcrete",
  384: "Brick",
  385: "BrickBlock",
  386: "MudBricks",
  387: "Paper",
  388: "Stick",
  389: "Lodestone",
  32768: "WoodenPick",
  32769: "CopperPick",
  32770: "IronPick",
  32771: "GoldPick",
  32772: "DiamondPick",
  32773: "NeptuniumPick",
  32774: "WoodenAxe",
  32775: "CopperAxe",
  32776: "IronAxe",
  32777: "GoldAxe",
  32778: "DiamondAxe",
  32779: "NeptuniumAxe",
  32780: "WoodenWhacker",
  32781: "CopperWhacker",
  32782: "IronWhacker",
  32783: "WoodenHoe",
  32784: "GoldBar",
  32785: "IronBar",
  32786: "Diamond",
  32787: "NeptuniumBar",
  32788: "Bucket",
  32789: "WaterBucket",
  32790: "WheatSlop",
  32791: "PumpkinSoup",
  32792: "MelonSmoothie",
  32793: "Battery",
  32794: "AnyLog",
  32795: "AnyPlank",
  32796: "AnyTerracotta",
  32797: "AnyLeaf",
  32798: "Player",
  32799: "Fragment"
};







